export const environment = {
  production: true,

  ROOT_API_URL: 'https://apiv2bo.yalocobro.com',
  API_URL: 'https://apiv2bo.yalocobro.com/api',
  API_SIGNALR: 'https://apiv2signalr.yalocobro.com/SignalR',
  URL_BACKOFFICE: 'https://admin.yalocobro.com/#/',

  VERSION: '4.5.1',

  // CryptoJS secret keys
  secretKey: 'jfakjfjkaBIPBIPfkabjfbakf',
  llaveSecreta: 'KMSls8Y.ls15ropUYLttewqqiYTWLLMQ',
  claveIv: 'GWSkjkq125.wli_l',
  googleMapsApiKey:'AIzaSyBiD8cxBm57QGVyp4CHGUreoZeKEpmH_go',

  // Mapbox GL JS
  MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoieWFsb3RlY2giLCJhIjoiY2xpa3I2Y2thMDI2aTNncDl6aXNtdThwayJ9.crOQ6YCqMchfyvk2buVJkw',
  MAPBOX_GEO_PLACES: 'https://api.mapbox.com/geocoding/v5/mapbox.places',

  publicKey: `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnFAACxIh8HalJysuLuCR
  I0xz69jHjKwhEsTEQ2FjMSObJIeo+fBhmpYBDsfVeLZHRXy1Um6hXuyQbd3Cya7n
  frzsRSKVddrCUh6PwfHA1gwTREhoIYd+2WuHZnAgeNO1ZZ1+wG9NPENhIGP0VQoH
  iwejGDGGTdd62Xr/hUPYF3A8BzfZDQ5dCjD4qmcV35TZknx+2hM+28ecWJGXahSi
  Yhi5Yf3RjLSl+a8ydt57Qoj019/hUCIE3Se3CpasNyK/xRnSSQFDK+Fla9CgcyIt
  uqEyRusmDBaPyADUHy/R8nuQ5AjtnsUuFIjGSOfKc5YDMdpxJZWOQW7RdPDxwApF
  4wIDAQAB
  -----END PUBLIC KEY-----`,

};
